import { render, staticRenderFns } from "./ReturnDeclareOrderManage.vue?vue&type=template&id=2cf1dbee&"
import script from "./ReturnDeclareOrderManage.vue?vue&type=script&lang=js&"
export * from "./ReturnDeclareOrderManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports